/*
 * "Pairs well with" on the product page (snippets/pdp-pairs-well.liquid).
 *
 * The list sits inside the main product form, so it cannot have forms of its
 * own. Each Add posts the one variant to the cart here, then publishes cartAdd:
 * mini-cart.js is subscribed to that and re-renders and opens the drawer, the
 * same response Add to Basket gets. Same pattern as moodboard-share.js.
 *
 * Each add carries the hidden line property _added_from = pairs-well-with onto
 * the order, so these sales can be counted exactly from Shopify orders
 * (lib/minicart-upsell-report.sh --source pairs-well-with in the package).
 * Once the basket has accepted it, the item gets a "swd:list-add" event, which
 * swd-list-tracking.js turns into the GA4 add. A refused add sends nothing.
 */
if (!customElements.get("pairs-well")) {
  customElements.define(
    "pairs-well",
    class PairsWell extends HTMLElement {
      connectedCallback() {
        this.error = this.querySelector(".pdp-pairs__error");
        this.addEventListener("click", (evt) => {
          const button = evt.target.closest(".js-pairs-add");
          if (button) this.add(button);
        });
      }

      add(button) {
        if (button.getAttribute("aria-disabled") === "true") return;
        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");
        this.showError(false);

        fetch(`${routes.cart_add_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(button.dataset.variantId),
                quantity: 1,
                properties: { _added_from: "pairs-well-with" },
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            // The cart API answers a refused add (sold out, over the stock
            // limit) with 422 and { status, description }.
            if (response.status) {
              this.showError(response.description || window.cartStrings?.error);
              return;
            }
            this.announce(button, response.items && response.items[0]);
            publish(PUB_SUB_EVENTS.cartAdd);
          })
          .catch((e) => {
            console.error(e);
            this.showError(window.cartStrings?.error);
          })
          .finally(() => {
            button.classList.remove("loading");
            button.removeAttribute("aria-disabled");
          });
      }

      // Tracking must never get in the way of the add, so any failure is swallowed.
      announce(button, line) {
        try {
          const item = button.closest("[data-swd-list-item]");
          if (!item) return;
          line = line || {};
          // /cart/add formats most prices as strings in pounds; these two are
          // pence. final_line_price is not always there.
          const pence = typeof line.final_line_price === "number" ? line.final_line_price : line.original_line_price;
          item.dispatchEvent(
            new CustomEvent("swd:list-add", {
              bubbles: true,
              detail: {
                quantity: line.quantity || 1,
                value: typeof pence === "number" ? pence / 100 : undefined,
              },
            })
          );
        } catch (e) {}
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || "";
        this.error.hidden = !message;
      }
    }
  );
}
